export { ORIENTATIONS as FIELD_ORIENTATIONS } from "@frontend/styles/constants";

export const FIELD_LABEL_ALIGNS = ["left", "right"] as const;

export const FIELD_LABEL_BLOCK_ALIGNS = ["center", "start"] as const;

export const FIELD_ERROR_DISPLAYS = ["block", "tooltip"] as const;
